module.exports = __webpack_public_path__ + "img/landing.67cb786d.png";